/*
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2024-07-03 14:41:15
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2024-07-03 14:41:23
 * @FilePath: /qd-yunjing-web/src/lib/bus.ts
 * @Description: bus
 */
/*
 * BUS 方法 参数具体参考three-model内使用方法
 * addDeviceLocation 添加图标，
 *  creatAreaTxt 区域内添加文案
 * addDeviceArea 添加区域
 * deleteRoomUnit 删除指定id的区域
 * resetCameraView 重置模型视角
 * addHeatMap 添加热力图
 * addCockpitHomeBoard 首页添加楼层指示文案
 * addSafetyRandomBoard
 * clearBoard 清除指定图标
 * clearAllBoard 清除所有图标
 */

import mitt from 'mitt';

type Events = {
  addDeviceLocation: any;
  creatAreaTxt: any;
  addDeviceArea: any;
  deleteRoomUnit: any;
  resetCameraView: any;
  addHeatMap: any;
  addCockpitHomeBoard: any;
  addSafetyRandomBoard: any;
  clearBoard: any;
  clearAllBoard?: any;
  chooseAnchor?: any;
  chooseArea: any;
  addModePoint: any;
  addPoint: any;
  setSpaceByOneID?: any;
  setDeviceLine?: any;
  backFlyLine?: any;
};

export default mitt<Events>();
